const errorRequest = (error) => {
  let err = { _error: 'Server Error. Please try again later' };
  if (error.response && error.response.data) {
    err = {
      ...error.response.data.errors,
      _error: error.response.data.error,
    };
  }
  return err;
};

function userOptions() {
  return (dispatch, getState, { api }) => {
    const ev = getState().globalParam;
    if (ev.isRequested || Object.keys(ev.sex).length) {
      return Promise.resolve();
    }
    dispatch({ type: 'GLOBAL_PARAM_REQUEST' });

    return api({
      method: 'GET',
      url: `/options/userOptions`,
      data: {},
    }).then(
      (data) => {
        const options = {
          sex: data.data.sexKey,
          messageDeleteAccount: data.data.MessageDeleteAccount,
        };

        dispatch({ type: 'GLOBAL_PARAM_SUCCESS', options });
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'GLOBAL_PARAM_FAILURE', errors: err });
      },
    );
  };
}

function goCheck(slugEvent, slugYacht, checkTicket, cb) {
  const params = {
    slugEvent,
    slugYacht,
  };
  if (checkTicket) {
    params.check_ticket = checkTicket;
  }
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'CHECK_REQUEST' });
    return api({
      method: 'GET',
      url: `/Event/check`,
      params,
    }).then(
      (data) => {
        const ticket = data.data.freeTicket;
        dispatch({ type: 'CHECK_SUCCESS', ticket });
        cb(null, data);
      },
      (error) => {
        const err = errorRequest(error);
        dispatch({ type: 'CHECK_FAILURE', errors: err });
        cb(err);
      },
    );
  };
}

function getSeoResultPage(category, country, callback) {
  return (dispatch, getState, { api }) => {
    dispatch({ type: 'GLOBAL_PARAMS_SEO_CHECK_DATA', category, country });
    if (
      !getState().globalParam.seo.active ||
      !getState().globalParam.seo.active.slug
    ) {
      return api({
        method: 'POST',
        url: `/SeoController/resultPage`,
        data: {
          category,
          country,
        },
      }).then(
        (data) => {
          const { textSeo } = data.data;
          dispatch({ type: 'GLOBAL_PARAMS_SEO_GET_DATA', result: textSeo });
        },
        (error) => {
          const err = errorRequest(error);
          callback(err);
        },
      );
    }
    return '';
  };
}

function getSeoResultPageForEdit(category, country, callback) {
  return (dispatch, getState, { api }) =>
    api({
      method: 'POST',
      url: `/SeoController/resultPage`,
      data: {
        category,
        country,
        isEdit: true,
      },
    }).then(
      (data) => {
        const { editData } = data.data;
        callback(null, editData || {});
      },
      (error) => {
        const err = errorRequest(error);
        callback(err);
      },
    );
}

export default {
  goCheck,
  userOptions,
  getSeoResultPage,
  getSeoResultPageForEdit,
};
